const EditorFromData = [
    {
        inputdata: "",
        title: "名称",
        fontSize: "14px",
        color: "#333333",
        placeholder: "请输入名称",
        types: "text",
        inputtype: "input",
        width: "850px",
        lablewith: "50px",
      },
      {
        inputdata: "",
        title: "缩写",
        fontSize: "14px",
        color: "#333333",
        placeholder: "请输入缩写",
        types: "text",
        inputtype: "input",
        width: "850px",
        lablewith: "50px",
      },
      {
        inputdata: "",
        title: "简称",
        fontSize: "14px",
        color: "#333333",
        placeholder: "请输入生产简称",
        types: "text",
        inputtype: "input",
        width: "850px",
        lablewith: "50px",
      },
];
export default EditorFromData;